import type {
  NextPage,
  GetStaticPropsContext,
} from 'next'
import each from 'lodash/each'
import isString from 'lodash/isString'
import {
  BlogPageProps,
  ENTRIES_MAP,
  getPagePropsBySlug,
} from 'BlogEntries'
import {
  BlogYear,
  BlogMonth,
  BlogEntry,
} from 'Blog'

type GetStaticPathsPaths = Array<string | {
  params: { slug: string[] }; locale?: string
}>

const Blog: NextPage<BlogPageProps> = ({
  type,
  ...restProps
}) => {
  switch (type) {
    case 'year':
      return <BlogYear type={type} {...restProps} />
    case 'month':
      return <BlogMonth type={type} {...restProps} />
    case 'entry':
      return <BlogEntry type={type} {...restProps} />
    default:
      return (
        <div>
          Error (TODO)
        </div>
      )
  }
}

// Double check:
// /blog/2015/7/warum-eigentlich-einen-extra-coach-fuer-frauen
// /blog/2015/8/wie-arbeitet-eigentlich-ein-systemischer-coach-therapeut
// /blog/2015/9/durch-systemisches-coaching-schaetze-finden-und-heben-1-9
// /blog/2015/9/durch-systemisches-coaching-schaetze-finden-und-heben-2-9
// /blog/2015/11/durch-systemisches-frauencoaching-schaetze-finden-und-heben-3-9
// /blog/2015/11/durch-systemisches-frauencoaching-schaetze-finden-und-heben-4-9
// /blog/2016/1/durch-systemisches-frauencoaching-schaetze-finden-und-heben-5-9
// /blog/2016/3/durch-systemisches-frauencoaching-schaetze-finden-und-heben-6-9
// /blog/2016/4/durch-systemisches-coaching-schaetze-finden-und-heben-7-9
// /blog/2016/5/durch-systemisches-frauencoaching-schaetze-finden-und-heben-8-9
// /blog/2016/6/durch-systemisches-frauencoaching-schaetze-finden-und-heben-9-9
// /blog/2016/7/berufung-und-beruf
// /blog/2016/7/maennerstrategien-kennen-und-parieren
// /blog/2016/11/balancekompetenzen
// /blog/2017/5/fundament-fuer-die-gleichberechtigung-von-frauen
// /blog/2017/12/methodenkoffer-das-systembrett

export function getStaticProps(context: GetStaticPropsContext) {
  let slug = context?.params?.slug || []
  if (isString(slug)) slug = [slug]

  return {
    props: { ...getPagePropsBySlug(slug) },
  }
}

// This function gets called at build time
export function getStaticPaths() {
  const paths: GetStaticPathsPaths = []

  each(ENTRIES_MAP, (months, year) => {
    paths.push({ params: { slug: [year] } })

    each(months, (posts, month) => {
      paths.push({ params: { slug: [year, `${parseInt(month)}`] } })

      each(posts, (post) => {
        paths.push({ params: {
          slug: [year, `${parseInt(month)}`, post.getUrl()]
        } })
      })
    })
  })


  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false }
}

export default Blog
